import(/* webpackMode: "eager" */ "/vercel/path0/src/app/adoption-application/page.tsx");
